import React from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import Footer from './Footer';
import PageHeader from './PageHeader';
import { NextSeo } from 'next-seo';
import i18next from 'i18next';
import { useRouter } from 'next/router';

const ContentPage = ({ children, useMeta, metaPagePath, ...props }) => {
  const router = useRouter();
  const lang = router.query.lang || 'en';

  return (
    <React.Fragment>
      {useMeta && (
        <NextSeo
          title={props.title}
          description={props.metaDescription}
          openGraph={{
            type: 'website',
            url: `https://www.doxer.io/${lang}/${metaPagePath}`,
            title: `Doxer.io | ${props.title}`,
            description: props.metaDescription,
            images: [
              {
                url: `https://www.doxer.io${props.backgroundImage}`,
                width: 2500,
                height: 1330,
                alt: i18next.t('meta.logo_alt', 'Doxer Medical Technologies LTD.'),
              },
            ],
          }}
        />
      )}
      <CssBaseline />
      <main style={{ background: props.background || '#fff' }}>
        <PageHeader {...props} />
        {children}
        <div style={{ margin: '70px 0' }}> </div>
      </main>
      <Footer />
    </React.Fragment>
  );
};

ContentPage.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  backgroundImage: PropTypes.string,
  metaPagePath: PropTypes.string,
  useMeta: PropTypes.bool,
  pageName: PropTypes.string,
};

ContentPage.defaultProps = {
  useMeta: false,
};

export default ContentPage;
